module.exports = __webpack_public_path__ + "img/elckerlijc.22d47441.png";